import { ValidatorFn, Validators } from '@angular/forms';
import { JSONSchema7 } from 'json-schema';

export const buildStringValidators = (property: any): ValidatorFn[] => {
  const validators: ValidatorFn[] = [];

  if (property.minLength) {
    validators.push(Validators.minLength(property.minLength));
  }

  if (property.maxLength) {
    validators.push(Validators.maxLength(property.maxLength));
  }

  if (property.pattern) {
    validators.push(Validators.pattern(property.pattern));
  }

  if (property.format) {
    switch (property.format) {
      case 'email':
        validators.push(Validators.email);
        break;
    }
  }

  return validators;
};

export const buildNumberValidators = (property: JSONSchema7): ValidatorFn[] => {
  const validators: ValidatorFn[] = [];

  if (property.minimum) {
    validators.push(Validators.min(property.minimum));
  }

  if (property.maximum) {
    validators.push(Validators.max(property.maximum));
  }

  return validators;
};
